export class ConditionalDataError extends Error {
  constructor(message) {
    super(message);
    this.name = 'ConditionalDataError';
  }
}

export class ConditionalStructureError extends Error {
  constructor(message) {
    super(message);
    this.name = 'ConditionalStructureError';
  }
}
